import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, ChevronDown, Phone } from 'lucide-react';
import { Container } from './Container';
const SPORTS = [{
  name: 'Baseball',
  path: '/sports/baseball'
}, {
  name: 'Basketball',
  path: '/sports/basketball'
}, {
  name: 'Football',
  path: '/sports/football'
}, {
  name: 'Softball',
  path: '/sports/softball'
}, {
  name: 'Soccer',
  path: '/sports/soccer'
}, {
  name: 'Cheer',
  path: '/sports/cheer'
}, {
  name: 'Volleyball',
  path: '/sports/volleyball'
}, {
  name: 'Track & Field',
  path: '/sports/track-field'
}, {
  name: 'Groupwear',
  path: '/sports/groupwear'
}];
export function Header() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isSportsDropdownOpen, setIsSportsDropdownOpen] = useState(false);
  const location = useLocation();
  const closeMenu = () => {
    setIsMobileMenuOpen(false);
    setIsSportsDropdownOpen(false);
  };
  return <header className="sticky top-0 z-50 w-full bg-white border-b border-gray-200 shadow-sm" data-id="element-95">
      {/* Top Utility Bar */}
      <div className="bg-gray-100 py-1.5 hidden sm:block" data-id="element-96">
        <Container className="flex justify-between items-center text-xs font-medium text-gray-600" data-id="element-97">
          <div className="flex items-center space-x-4" data-id="element-98">
            <span data-id="element-99">Factory-Direct Custom Uniforms</span>
            <span className="text-gray-300" data-id="element-100">|</span>
            <span className="text-pts-red font-bold" data-id="element-101">We Beat All Quotes</span>
          </div>
          <div className="flex items-center space-x-4" data-id="element-102">
            <Link to="/my-account" className="hover:text-pts-red transition-colors" data-id="element-103">
              My Account
            </Link>
          </div>
        </Container>
      </div>

      {/* Main Header */}
      <Container data-id="element-104">
        <div className="flex justify-between items-center h-20" data-id="element-105">
          {/* Logo */}
          <Link to="/" onClick={closeMenu} className="flex-shrink-0 flex items-center gap-3" data-id="element-106">
            <img src="https://cdn.magicpatterns.com/uploads/gWFT4ncmNMgwJGpFpp5fGQ/PTS-logo-clean-black-transparent.png" alt="Primetime Sports Apparel" className="h-10 sm:h-12 w-auto" data-id="element-107" />
            <span className="hidden sm:flex flex-col leading-tight border-l border-gray-200 pl-3" data-id="element-108">
              <span className="font-oswald text-sm font-bold uppercase tracking-wide text-gray-900" data-id="element-109">
                Primetime Sports
              </span>
              <span className="font-oswald text-sm font-bold uppercase tracking-wide text-gray-900" data-id="element-110">
                Apparel
              </span>
            </span>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8" data-id="element-111">
            <div className="relative group" onMouseEnter={() => setIsSportsDropdownOpen(true)} onMouseLeave={() => setIsSportsDropdownOpen(false)} data-id="element-112">
              <button className="flex items-center text-gray-900 hover:text-pts-red font-medium transition-colors py-8" data-id="element-113">
                Sports <ChevronDown className="ml-1 h-4 w-4" data-id="element-114" />
              </button>

              {isSportsDropdownOpen && <div className="absolute top-full left-0 w-48 bg-white shadow-lg border border-gray-100 rounded-b-md py-2" data-id="element-115">
                  {SPORTS.map(sport => <Link key={sport.path} to={sport.path} className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 hover:text-pts-red" onClick={closeMenu} data-id="element-116">
                      {sport.name}
                    </Link>)}
                </div>}
            </div>

            <Link to="/team-stores" className="text-gray-900 hover:text-pts-red font-medium transition-colors" data-id="element-117">
              Team Stores
            </Link>
            <Link to="/process" className="text-gray-900 hover:text-pts-red font-medium transition-colors" data-id="element-118">
              Our Process
            </Link>
            <Link to="/about" className="text-gray-900 hover:text-pts-red font-medium transition-colors" data-id="element-119">
              About
            </Link>
            <Link to="/contact" className="text-gray-900 hover:text-pts-red font-medium transition-colors" data-id="element-120">
              Contact
            </Link>
          </nav>

          {/* Desktop Actions */}
          <div className="hidden lg:flex items-center space-x-6" data-id="element-121">
            <a href="tel:8882188647" className="flex items-center text-gray-900 font-bold hover:text-pts-red transition-colors" data-id="element-122">
              <Phone className="h-4 w-4 mr-2 text-pts-red" data-id="element-123" />
              888.218.8647
            </a>
            <Link to="/get-started" className="bg-pts-red hover:bg-pts-red-dark text-white px-6 py-2.5 rounded font-bold uppercase tracking-wide text-sm transition-colors" data-id="element-124">
              Start My Team Order
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <div className="lg:hidden flex items-center" data-id="element-125">
            <a href="tel:8882188647" className="mr-4 text-pts-red" data-id="element-126">
              <Phone className="h-5 w-5" data-id="element-127" />
            </a>
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="text-gray-900 hover:text-pts-red p-2" data-id="element-128">
              {isMobileMenuOpen ? <X className="h-6 w-6" data-id="element-129" /> : <Menu className="h-6 w-6" data-id="element-130" />}
            </button>
          </div>
        </div>
      </Container>

      {/* Mobile Menu */}
      {isMobileMenuOpen && <div className="lg:hidden bg-white border-t border-gray-100 absolute w-full shadow-lg max-h-[calc(100vh-80px)] overflow-y-auto" data-id="element-131">
          <div className="px-4 pt-2 pb-6 space-y-1" data-id="element-132">
            <div className="py-2" data-id="element-133">
              <p className="px-3 text-xs font-bold text-gray-400 uppercase tracking-wider" data-id="element-134">
                Sports
              </p>
              <div className="mt-2 grid grid-cols-2 gap-1 px-3" data-id="element-135">
                {SPORTS.map(sport => <Link key={sport.path} to={sport.path} className="block py-2 text-sm font-medium text-gray-900" onClick={closeMenu} data-id="element-136">
                    {sport.name}
                  </Link>)}
              </div>
            </div>

            <div className="border-t border-gray-100 my-2" data-id="element-137"></div>

            <Link to="/team-stores" onClick={closeMenu} className="block px-3 py-3 text-base font-medium text-gray-900" data-id="element-138">
              Team Stores
            </Link>
            <Link to="/process" onClick={closeMenu} className="block px-3 py-3 text-base font-medium text-gray-900" data-id="element-139">
              Our Process
            </Link>
            <Link to="/about" onClick={closeMenu} className="block px-3 py-3 text-base font-medium text-gray-900" data-id="element-140">
              About
            </Link>
            <Link to="/contact" onClick={closeMenu} className="block px-3 py-3 text-base font-medium text-gray-900" data-id="element-141">
              Contact
            </Link>

            <div className="border-t border-gray-100 my-4" data-id="element-142"></div>

            <div className="px-3 flex flex-col space-y-3" data-id="element-143">
              <a href="tel:8882188647" className="flex items-center justify-center w-full border-2 border-gray-200 text-gray-900 px-4 py-3 rounded font-bold text-sm" data-id="element-144">
                <Phone className="h-4 w-4 mr-2" data-id="element-145" />
                Call 888.218.8647
              </a>
              <Link to="/get-started" onClick={closeMenu} className="flex items-center justify-center w-full bg-pts-red text-white px-4 py-3 rounded font-bold uppercase tracking-wide text-sm" data-id="element-146">
                Start My Team Order
              </Link>
            </div>
          </div>
        </div>}
    </header>;
}